// src/components/common/SearchBar/SearchBar.jsx
import React, { useState, useEffect } from 'react';
import useDebounce from '../../../hooks/useDebounce';
import styles from './SearchBar.module.css';

const SearchBar = ({
    placeholder = 'Buscar...',
    onSearch,
    disabled = false,
    debounceDelay = 300,
    initialValue = '',
}) => {
    const [searchTerm, setSearchTerm] = useState(initialValue);
    const debouncedSearchTerm = useDebounce(searchTerm, debounceDelay);

    useEffect(() => {
        onSearch(debouncedSearchTerm);
    }, [debouncedSearchTerm, onSearch]);

    return (
        <div className={styles.searchWrapper}>
            <svg
                className={styles.searchIcon}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
            </svg>
            <input
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles.searchInput}
                disabled={disabled}
            />
            {searchTerm && (
                <button
                    onClick={() => setSearchTerm('')}
                    className={styles.clearSearch}
                    title="Limpar busca"
                >
                    ✕
                </button>
            )}
        </div>
    );
};

export default SearchBar;